export default class ShoppableContent {
  constructor({ element }) {
    this.element = element;
    this.openBtns = element.querySelectorAll('[data-shoppable-open]');
    this.wrappers = element.querySelectorAll('[data-shoppable-content]');
    this.init();
  }

  init() {
    this.openBtns.forEach((btn) => {
      btn.addEventListener('click', () => this.initOpenShoppable(btn));
    });
    this.wrappers.forEach((wrapper) => {
      wrapper.addEventListener('click', () => this.initCloseShoppable(wrapper));
    });
  }

  initOpenShoppable(btn) {
    const shoppable = this.element.querySelector(
      `[data-shoppable-content="${btn.dataset.shoppableOpen}"]`,
    );
    if (shoppable) {
      shoppable.classList.remove('!invisible');
      this.element.classList.add('shoppable-open');
    }
  }

  initCloseShoppable(wrapper) {
    const shoppableList = wrapper.querySelector(`[data-shoppable-list]`);
    shoppableList.addEventListener('click', (e) => e.stopPropagation());
    if (shoppableList) {
      wrapper.classList.add('!invisible');
      this.element.classList.remove('shoppable-open');
    }
  }
}
